import { request } from '@/api/v2/core';
import * as RowStatusTypes from '@/@types/rowStatusTypes';

/**
 * Retrieves the row status objects from the database containing ids, user-friendly names, and UI colors
 * @returns {Promise<RowStatusTypes.RowStatus[]>}
 */
export const fetchRowStatuses = () => {
  return request('row-statuses', {
    method: 'GET'
  });
};
